.breadcrumb-divider{color:#232426;opacity:.12}.saving{color:#232426;opacity:.6}
/*# sourceMappingURL=saving-indicator.component.css.map */
